var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.285 9H17.715C12.255 9 9 12.255 9 17.715V30.27C9 35.745 12.255 39 17.715 39H30.27C35.73 39 38.985 35.745 38.985 30.285V17.715C39 12.255 35.745 9 30.285 9Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.835 18.1655C27.615 15.9605 24.015 15.9605 21.81 18.1655C20.265 19.6955 19.8 21.9155 20.4 23.8655L16.875 27.3905C16.635 27.6455 16.455 28.1405 16.515 28.5005L16.74 30.1355C16.815 30.6755 17.325 31.1855 17.865 31.2605L19.5 31.5005C19.86 31.5455 20.355 31.3955 20.61 31.1255L21.225 30.5105C21.375 30.3755 21.375 30.1355 21.225 29.9855L19.77 28.5305C19.56 28.3205 19.56 27.9605 19.77 27.7355C19.98 27.5255 20.34 27.5255 20.565 27.7355L22.02 29.1905C22.155 29.3255 22.395 29.3255 22.545 29.1905L24.135 27.6155C26.07 28.2155 28.29 27.7505 29.835 26.2205C32.055 23.9855 32.055 20.3855 29.835 18.1655ZM25.875 24.0005C24.84 24.0005 24 23.1605 24 22.1255C24 21.0905 24.84 20.2505 25.875 20.2505C26.91 20.2505 27.75 21.0905 27.75 22.1255C27.75 23.1605 26.91 24.0005 25.875 24.0005Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.7ad37f16f9b1a2f1f03c96031aff5568.svg";
export { ForwardRef as ReactComponent };